import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';

import Download from '../Download';
import resyUsersImg from '../../images/404.png';

const ErrorView = (props) => {
  const {
    Analytics,
    $rootScope,
    $translate,
  } = props;

  $rootScope.metadata.bodyClasses = 'page-error';

  Analytics.event('404', {
    category: 'Error',
    label: `${window.location.pathname}${window.location.search}`,
  });

  return (
    <div className="ErrorView">
      <img
        src={resyUsersImg}
        alt="Two Beautiful Resy Users"
        aria-hidden="true"
      />

      <h1>
        <span>Sorry, but we can’t find that page. Please check that the address is correct or go back to the </span>
        <a href="/">home page</a>
        <span>.</span>
      </h1>
      <a href="/" className="home-button">Home Page</a>
      <resy-download>
        <Provider store={$rootScope.reduxStore}>
          <Download
            $translate={$translate}
          />
        </Provider>
      </resy-download>
    </div>
  );
};

ErrorView.propTypes = {
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  $rootScope: PropTypes.shape({
    metadata: PropTypes.shape({
      bodyClasses: PropTypes.string,
    }),
    reduxStore: PropTypes.shape({
      dispatch: PropTypes.func,
      getState: PropTypes.func,
      subscribe: PropTypes.func,
    }),
  }).isRequired,
  $translate: PropTypes.shape({
    proposedLanguage: PropTypes.func.isRequired,
    use: PropTypes.func.isRequired,
  }).isRequired,
};

export default ErrorView;
